(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
// Enhanced dropdown functionality with better performance
document.addEventListener('DOMContentLoaded', function() {
  // Improved sticky header with scroll throttling
  let ticking = false;
  let lastScrollY = 0;
  
  function updateStickyHeader() {
    const header = document.querySelector('.sticky-header');
    if (!header) return;
    
    const currentScrollY = window.scrollY;
    
    if (currentScrollY > 100) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
    
    lastScrollY = currentScrollY;
    ticking = false;
  }
  
  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(updateStickyHeader);
      ticking = true;
    }
  }
  
  window.addEventListener('scroll', requestTick, { passive: true });
  
  // Enhanced dropdown behavior
  const dropdowns = document.querySelectorAll('.ul-menu li');
  let activeDropdown = null;
  
  dropdowns.forEach(dropdown => {
    const submenu = dropdown.querySelector('.submenu_ul');
    if (!submenu) return;
    
    let hoverTimeout;
    
    dropdown.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      if (activeDropdown && activeDropdown !== dropdown) {
        const activeSubmenu = activeDropdown.querySelector('.submenu_ul');
        if (activeSubmenu) {
          activeSubmenu.style.opacity = '0';
          activeSubmenu.style.visibility = 'hidden';
        }
      }
      activeDropdown = dropdown;
      submenu.style.opacity = '1';
      submenu.style.visibility = 'visible';
    });
    
    dropdown.addEventListener('mouseleave', () => {
      hoverTimeout = setTimeout(() => {
        submenu.style.opacity = '0';
        submenu.style.visibility = 'hidden';
        if (activeDropdown === dropdown) {
          activeDropdown = null;
        }
      }, 150);
    });
  });
  
  // Keyboard navigation support
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && activeDropdown) {
      const submenu = activeDropdown.querySelector('.submenu_ul');
      if (submenu) {
        submenu.style.opacity = '0';
        submenu.style.visibility = 'hidden';
      }
      activeDropdown = null;
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
